import { Portal } from '@/components';
import { useProperties, useFormProps, useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import FormWindow from './FormWindow';
import FeedbackButton from './FeedbackButton';
import CloseButton from './CloseButton';
import BaseForm from './BaseForm';
import LanguageToggle from './LanguageToggle';

export default function SlideInForm() {
	const {
		feedbackButtonRef,
		closeButtonRef,
		formBodyRef,
		wrapStyle,
		buttonType,
		formType,
		position,
		formOpen,
		screenshotActive,
		actions: formActions
	} = useFormStore();
	const { formKey } = useFormProps();
	const { conversational, translation = {} } = useProperties();
	const { themeClass } = useConfigStore();
	return (
		<Portal into={document.body}>
			<div
				className={`mopinion-survey-content wcag ${themeClass}`}
				data-mop-form-type={formType}
			>
				<div
					id="surveyWindowWrap"
					class={`surveyWindowWrap mopinion-slider slide-${position} ${
						formOpen ? 'mopinion-slider-active' : ''
					} ${screenshotActive ? 'screen-capture-active' : ''}`}
					data-parent-for={formKey}
					style={wrapStyle}
					onKeyDown={e => formActions.handleWCAGkeyEvents(e)}
				>
					<div
						class="surveySliderScroller"
						id="surveySliderScroller"
						style={
							!conversational
								? {
										maxHeight: '80vh',
										overflowY: 'auto',
										'-webkit-overflow-scrolling': 'touch',
										'-ms-overflow-style': '-ms-autohiding-scrollbar'
								  }
								: {
										overflow: 'hidden'
								  }
						}
					>
						<FormWindow>
							<div
								id="surveyBody"
								style={{ overflow: 'hidden' }}
								className="mopinion-slide"
								ref={formBodyRef}
								role="dialog"
								aria-labelledby={`surveyTitle-${formKey}`}
							>
								<CloseButton ref={closeButtonRef} />
								{translation?.useTranslation && translation?.useToggle && (
									<LanguageToggle />
								)}
								<BaseForm />
							</div>
						</FormWindow>
					</div>
					{buttonType === 'label' && <FeedbackButton ref={feedbackButtonRef} />}
				</div>
				{buttonType === 'float' && <FeedbackButton ref={feedbackButtonRef} />}
			</div>
		</Portal>
	);
}
